import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import globals from '@/globals'
// web端
import webHomeRouters from './webRouter/home'
// 管理后台
import loginRoutes from './adminRouter/login'
import shop from './adminRouter/shopdetail'
import shopWaiter from './adminRouter/shopWaiter'
import activitysRoutes from './adminRouter/activitys'
import orderRoutes from './adminRouter/order'
import homeRoutes from './adminRouter/home'
import roleRoutes from './adminRouter/role'
import couponRoutes from './adminRouter/coupon'
import dashboardRoutes from './adminRouter/dashboard'
import activityCountRouters from './adminRouter/activityCount'
import ticketRouters from './adminRouter/ticket'
import orderSatisticRouters from './adminRouter/orderStatistic'
// import commentRouters from './adminRouter/comment'
import userCouponsRouters from './adminRouter/userCoupons'
import shoproleRouters from './adminRouter/shopRoles'
import activitySessionRoutes from './adminRouter/activitySession'
import activityTicketRouters from './adminRouter/activityTicket'
import qrcodeRouters from './adminRouter/qrcode'
import pointsRouters from './adminRouter/points'
import merchantCouponRouters from './adminRouter/merchantCoupon'
import userGoods from './adminRouter/userGoods'
import room from './adminRouter/room'


import { ROUTERMODE } from '@/util/env.js'

Vue.use(Router)
Vue.use(Meta)

const ROUTES = [
  // Default route
  { path: '', redirect: '/index'}
]
  .concat(loginRoutes)
  .concat(shop)
  .concat(shopWaiter)
  .concat(activitysRoutes)
  .concat(orderRoutes)
  .concat(homeRoutes)
  .concat(roleRoutes)
  .concat(couponRoutes)
  .concat(dashboardRoutes)
  .concat(activityCountRouters)
  .concat(ticketRouters)
  .concat(orderSatisticRouters)
  // .concat(commentRouters)
  .concat(userCouponsRouters)
  .concat(shoproleRouters)
  .concat(activitySessionRoutes)
  .concat(activityTicketRouters)
  .concat(qrcodeRouters)
  .concat(pointsRouters)
  .concat(webHomeRouters)
  .concat(merchantCouponRouters)
  .concat(userGoods)
  .concat(room)

const router = new Router({
  base: '/',
  mode: ROUTERMODE,
  routes: ROUTES
})

router.afterEach(() => {
  // Remove initial splash screen
  const splashScreen = document.querySelector('.app-splash-screen')
  if (splashScreen) {
    splashScreen.style.opacity = 0
    setTimeout(() => splashScreen && splashScreen.parentNode.removeChild(splashScreen), 300)
  }

  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  // Set loading state
  document.body.classList.add('app-loading')

  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10)
})

export default router
